import { useEffect } from 'react';

interface SeoConfig {
  title: string;
  description: string;
  canonicalPath: string;
}

const SITE_URL = 'https://www.finbuffer.app';

function updateMeta(attribute: 'name' | 'property', key: string, content: string) {
  let meta = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attribute, key);
    document.head.appendChild(meta);
  }
  meta.content = content;
}

export function useSeo({ title, description, canonicalPath }: SeoConfig) {
  useEffect(() => {
    document.title = title;
    const canonicalUrl = new URL(canonicalPath, SITE_URL).toString();

    updateMeta('name', 'description', description);
    updateMeta('name', 'robots', 'index,follow');
    updateMeta('property', 'og:title', title);
    updateMeta('property', 'og:description', description);
    updateMeta('property', 'og:url', canonicalUrl);

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;
  }, [title, description, canonicalPath]);
}
